import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import React from 'react';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import { DOMModalContextProvider } from '../../../../Services/DOMModalContext';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import QuestionnairePlanningModal from './QuestionnairePlanningModal';

loadDOMComponent({
	selector: 'react-questionnaire-planning-modal',
	callback: ({ container, context, props }) => {
		const patientId = container.getAttribute('patientId');
		const toggleId = container.getAttribute('toggleId');
		const scheduleId = container.getAttribute('scheduleId');

		const handleCloseModal = () => {
			window.location.reload();
		};

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<DOMModalContextProvider toggleId={toggleId}>
							<QuestionnairePlanningModal
								opened={false}
								onClose={handleCloseModal}
								patientId={patientId}
								scheduleId={scheduleId}
							/>
						</DOMModalContextProvider>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
